angular.module("listingOverviewModule").component("listingOffMarket", {
    templateUrl: "listingOffMarket/listingOffMarket.html",
    bindings: {
        rpc: '@',
        user: '<',
        buildingToken: '@',
        listingToken: '@',
        buildingName: '@'
    },
    controller: ["$timeout", "$element", function($timeout, $element) {
        this.$onInit = function() {
            
        };
    }]
});
